// Comprime una imagen en el navegador (redimensiona + re-encodea a JPEG)
// para que la subida de evidencias sea rápida incluso con fotos de cámara.
// Devuelve un File comprimido; si no se puede comprimir (PDF, GIF/SVG,
// error de decodificación o si el resultado pesa más que el original),
// devuelve el archivo sin modificar.
export async function compressImage(file, { maxDimension = 1920, quality = 0.8 } = {}) {
  const incompressibles = ['image/gif', 'image/svg+xml'];
  if (!file.type || !file.type.startsWith('image/') || incompressibles.includes(file.type)) {
    return file;
  }
  if (file.size < 300 * 1024) {
    return file; // ya pesa poco, no vale la pena re-encodear
  }
  try {
    const image = await loadImage(file);
    const scale = Math.min(1, maxDimension / Math.max(image.width, image.height));
    const width = Math.max(1, Math.round(image.width * scale));
    const height = Math.max(1, Math.round(image.height * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; // evita fondo negro en PNG con transparencia
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(image, 0, 0, width, height);
    if (typeof image.close === 'function') image.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob || blob.size >= file.size) return file;

    const name = (file.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg' });
  } catch (error) {
    console.warn('No se pudo comprimir la imagen, se subirá el original:', error);
    return file;
  }
}

async function loadImage(file) {
  if (typeof createImageBitmap === 'function') {
    try {
      // 'from-image' respeta la orientación EXIF de las fotos de cámara
      return await createImageBitmap(file, { imageOrientation: 'from-image' });
    } catch (error) {
      // navegador sin soporte para este formato vía bitmap; cae al fallback
    }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };
    img.src = url;
  });
}
